module.exports = __webpack_public_path__ + "img/taquile.e9069b75.jpg";